/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CardInfo } from './CardInfo';
import {
    CardInfoFromJSON,
    CardInfoFromJSONTyped,
    CardInfoToJSON,
} from './CardInfo';

/**
 * 
 * @export
 * @interface RegisterCardInput
 */
export interface RegisterCardInput {
    /**
     * Payment Account ID
     * @type {string}
     * @memberof RegisterCardInput
     */
    accountId: string;
    /**
     * 
     * @type {CardInfo}
     * @memberof RegisterCardInput
     */
    card: CardInfo;
    /**
     * Leave Empty
     * @type {string}
     * @memberof RegisterCardInput
     */
    specialConfiguration?: string;
}

/**
 * Check if a given object implements the RegisterCardInput interface.
 */
export function instanceOfRegisterCardInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "accountId" in value;
    isInstance = isInstance && "card" in value;

    return isInstance;
}

export function RegisterCardInputFromJSON(json: any): RegisterCardInput {
    return RegisterCardInputFromJSONTyped(json, false);
}

export function RegisterCardInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterCardInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accountId': json['accountId'],
        'card': CardInfoFromJSON(json['card']),
        'specialConfiguration': !exists(json, 'specialConfiguration') ? undefined : json['specialConfiguration'],
    };
}

export function RegisterCardInputToJSON(value?: RegisterCardInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accountId': value.accountId,
        'card': CardInfoToJSON(value.card),
        'specialConfiguration': value.specialConfiguration,
    };
}

